module.exports = __webpack_public_path__ + "img/ANTENNA PALMA RED.f3d97cc.svg";